import { render, staticRenderFns } from "./DispatchPatternList.vue?vue&type=template&id=b94d7e30&scoped=true&lang=pug"
import script from "./DispatchPatternList.vue?vue&type=script&lang=js"
export * from "./DispatchPatternList.vue?vue&type=script&lang=js"
import style0 from "./DispatchPatternList.vue?vue&type=style&index=0&id=b94d7e30&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94d7e30",
  null
  
)

export default component.exports